var _excluded = ["a11yTitle"],
  _excluded2 = ["size", "disabled", "onClick", "children", "LeftIcon", "RightIcon", "tabIndex", "fit", "name", "value", "className", "type"],
  _excluded3 = ["as"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["children"],
  _excluded8 = ["open", "disableEscapeKeyDown", "onClose", "children", "showCloseButton", "showOverlay", "container", "size"],
  _excluded9 = ["src", "autoPlay", "image", "modal", "isRunning"],
  _excluded10 = ["src", "modal"],
  _excluded11 = ["image", "onClick"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { jsx as l, jsxs as k } from "react/jsx-runtime";
import { useEffect as L, useState as P, forwardRef as h, useRef as z } from "react";
import { styled as r, css as a, createGlobalStyle as H } from "styled-components";
import { createPortal as Z } from "react-dom";
var G = r.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
r.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
r.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
r.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
r(G)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
r.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
r.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref) {
  var e = _ref.theme;
  return e.colors.red50;
});
a(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref2) {
  var e = _ref2.theme.down;
  return e("tablet");
});
var A = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  F = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  R = "0px 4px 28px rgba(0, 0, 0, 0.14)";
a(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], A);
var M = a(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], F);
a(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], R);
a(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], A);
a(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], F);
a(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], R);
var X = function X(e, t) {
    L(function () {
      var n = function n(o) {
        Array.isArray(e) && e.some(function (s) {
          return !s.current || s.current.contains((o == null ? void 0 : o.target) || null);
        }) || !Array.isArray(e) && (!e.current || e.current.contains((o == null ? void 0 : o.target) || null)) || t(o);
      };
      return document.addEventListener("mousedown", n), document.addEventListener("touchstart", n), function () {
        document.removeEventListener("mousedown", n), document.removeEventListener("touchstart", n);
      };
    }, [e, t]);
  },
  Y = function Y() {
    var _P = P(!0),
      _P2 = _slicedToArray(_P, 2),
      e = _P2[0],
      t = _P2[1];
    return L(function () {
      t(!1);
    }, []), e;
  },
  K = function K(e, t) {
    return t in e.colors;
  },
  q = {
    desktop: "1440px",
    tablet: "1080px",
    tabletMd: "1024px",
    tabletSm: "768px",
    phone: "640px",
    phoneSm: "320px"
  },
  J = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
H(["", " img{max-width:100%;height:auto;object-fit:contain;}body{min-width:", ";}body,button,input{font-family:", ";color:", ";}p,a,h1,h2,h3,h4,h5,input,hr,button,section,menu{margin:0;padding:0;}div,section,input,button{box-sizing:border-box;}input{outline:none;}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus{transition:background-color 100s ease-in-out 0s;}button{border:none;}"], J, q.phoneSm, function (_ref3) {
  var e = _ref3.theme;
  return e.fontFamily;
}, function (_ref4) {
  var e = _ref4.theme;
  return e.colors.black10;
});
var Q = a(["", ";g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{stroke:none;}*[fill-rule],*[FILL-RULE],*[fill*='#']:not([fill='#FFF']),*[FILL*='#']:not([FILL='#FFF']){fill:inherit;}"], function (_ref5) {
    var _t$colors$n;
    var e = _ref5.color,
      t = _ref5.theme,
      n = _ref5.disabled;
    var o;
    return n ? o = typeof n == "string" ? (_t$colors$n = t.colors[n]) !== null && _t$colors$n !== void 0 ? _t$colors$n : n : t.colors.black80 : e && K(t, e) ? o = t.colors[e] : o = e || t.colors.icon, a(["fill:", ";stroke:", ";"], o, o);
  }),
  $ = 24,
  ee = function ee(e) {
    var t = e.match(/\d+(\.\d+)?/);
    return t ? parseFloat(t[0]) : $;
  },
  te = r.svg(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", ";\n"])), function (_ref6) {
    var _ref6$size = _ref6.size,
      e = _ref6$size === void 0 ? $ : _ref6$size,
      t = _ref6.theme,
      n = _ref6.viewBox;
    var _split = (n || "0 0 ".concat($, " ").concat($)).split(" "),
      _split2 = _slicedToArray(_split, 4),
      o = _split2[2],
      i = _split2[3],
      s = +o / +i,
      c = ee(t.icons.size[e] || "".concat(e, "px"));
    return o < i ? "\n      width: ".concat(c, "px;\n      height: ").concat(c / s, "px;\n    ") : i < o ? "\n      width: ".concat(c * s, "px;\n      height: ").concat(c, "px;\n    ") : "\n      width: ".concat(c, "px;\n      height: ").concat(c, "px;\n    ");
  }, function (_ref7) {
    var e = _ref7.$hasOwnColorPattern;
    return e ? void 0 : Q;
  }),
  j = function j(_ref8) {
    var e = _ref8.a11yTitle,
      t = _objectWithoutProperties(_ref8, _excluded);
    return /* @__PURE__ */l(te, _objectSpread(_objectSpread({}, t), {}, {
      name: e
    }));
  },
  V = function V(e) {
    return /* @__PURE__ */l(j, _objectSpread(_objectSpread({
      viewBox: "0 0 24 24",
      a11yTitle: "Cancel"
    }, e), {}, {
      children: /* @__PURE__ */l("path", {
        d: "M12 2.5C6.47 2.5 2 6.97 2 12.5C2 18.03 6.47 22.5 12 22.5C17.53 22.5 22 18.03 22 12.5C22 6.97 17.53 2.5 12 2.5ZM16.3 16.8C15.91 17.19 15.28 17.19 14.89 16.8L12 13.91L9.11 16.8C8.72 17.19 8.09 17.19 7.7 16.8C7.31 16.41 7.31 15.78 7.7 15.39L10.59 12.5L7.7 9.61C7.31 9.22 7.31 8.59 7.7 8.2C8.09 7.81 8.72 7.81 9.11 8.2L12 11.09L14.89 8.2C15.28 7.81 15.91 7.81 16.3 8.2C16.69 8.59 16.69 9.22 16.3 9.61L13.41 12.5L16.3 15.39C16.68 15.77 16.68 16.41 16.3 16.8Z",
        fill: "#0091DF"
      })
    }));
  };
V.displayName = "Cancel";
var N = function N(e) {
  return /* @__PURE__ */k(j, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "Play"
  }, e), {}, {
    children: [/* @__PURE__ */l("path", {
      d: "M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM9.8 15.85V8.15C9.8 7.699 10.317 7.435 10.68 7.71L15.817 11.56C16.114 11.78 16.114 12.22 15.817 12.44L10.68 16.29C10.317 16.565 9.8 16.301 9.8 15.85Z",
      fill: "#0091DF"
    }), /* @__PURE__ */l("path", {
      d: "M16.5661 11.3711C17.0018 11.6686 17.0018 12.3115 16.5661 12.609L10.4071 16.8147C9.91008 17.154 9.23633 16.7978 9.23633 16.1957L9.23633 7.78441C9.23633 7.18228 9.91008 6.82607 10.4071 7.16545L16.5661 11.3711Z",
      fill: "#FFF"
    })]
  }));
};
N.displayName = "Play";
/**
 * tua-body-scroll-lock v1.5.3
 * (c) 2024 Evinma, BuptStEve
 * @license MIT
 */
var C = function C() {
    return typeof window > "u";
  },
  _ = function _(t) {
    t = t || navigator.userAgent;
    var n = /(iPad).*OS\s([\d_]+)/.test(t),
      o = !n && /(iPhone\sOS)\s([\d_]+)/.test(t),
      i = /(Android);?[\s/]+([\d.]+)?/.test(t),
      s = o || n;
    return {
      ios: s,
      android: i
    };
  };
function D(e) {
  if (C()) return !1;
  if (!e) throw new Error("options must be provided");
  var t = !1,
    n = {
      get passive() {
        t = !0;
      }
    },
    o = function o() {},
    i = "__TUA_BSL_TEST_PASSIVE__";
  window.addEventListener(i, o, n), window.removeEventListener(i, o, n);
  var s = e.capture;
  return t ? e : typeof s < "u" ? s : !1;
}
function ne(e) {
  return e || e === null || process.env.NODE_ENV === "production" ? !1 : (process.env.NODE_ENV !== "test" && console.warn("If scrolling is also required in the floating layer, the target element must be provided."), !0);
}
function E() {
  return "__BSL_PREVENT_DEFAULT__" in window || (window.__BSL_PREVENT_DEFAULT__ = function (e) {
    e.cancelable && e.preventDefault();
  }), window.__BSL_PREVENT_DEFAULT__;
}
function oe(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var y = {
  lockedNum: 0,
  lockedElements: [],
  unLockCallback: null,
  documentListenerAdded: !1,
  initialClientPos: {
    clientX: 0,
    clientY: 0
  }
};
function S(e) {
  if (C()) return y;
  if (!(e != null && e.useGlobalLockState)) return S.lockState;
  var t = "__BSL_LOCK_STATE__" in window ? Object.assign(Object.assign({}, y), window.__BSL_LOCK_STATE__) : y;
  return window.__BSL_LOCK_STATE__ = t, t;
}
S.lockState = y;
function ie(e, t, n) {
  if (t) {
    var o = t.scrollTop,
      i = t.scrollLeft,
      s = t.scrollWidth,
      c = t.scrollHeight,
      u = t.clientWidth,
      b = t.clientHeight,
      p = e.targetTouches[0].clientX - n.clientX,
      g = e.targetTouches[0].clientY - n.clientY,
      f = Math.abs(g) > Math.abs(p),
      v = g > 0 && o === 0,
      w = p > 0 && i === 0,
      d = p < 0 && i + u + 1 >= s,
      m = g < 0 && o + b + 1 >= c;
    if (f && (v || m) || !f && (w || d)) return E()(e);
  }
  return e.stopPropagation(), !0;
}
function re() {
  var e = document.documentElement,
    t = Object.assign({}, e.style),
    n = window.innerWidth - e.clientWidth,
    o = parseInt(window.getComputedStyle(e).paddingRight, 10);
  return e.style.overflow = "hidden", e.style.boxSizing = "border-box", e.style.paddingRight = "".concat(n + o, "px"), function () {
    ["overflow", "boxSizing", "paddingRight"].forEach(function (i) {
      e.style[i] = t[i] || "";
    });
  };
}
function le(e) {
  var t = document.documentElement,
    n = document.body,
    o = t.scrollTop || n.scrollTop,
    i = Object.assign({}, t.style),
    s = Object.assign({}, n.style);
  return t.style.height = "100%", t.style.overflow = "hidden", n.style.top = "-".concat(o, "px"), n.style.width = "100%", n.style.height = "auto", n.style.position = "fixed", n.style.overflow = "hidden", function () {
    t.style.height = i.height || "", t.style.overflow = i.overflow || "", ["top", "width", "height", "overflow", "position"].forEach(function (u) {
      n.style[u] = s[u] || "";
    });
    var c = ("scrollBehavior" in document.documentElement.style);
    c ? window.scrollTo({
      top: o,
      behavior: "instant"
    }) : window.scrollTo(0, o);
  };
}
function se(e, t) {
  if (!C()) {
    ne(e);
    var n = _(),
      o = S(t);
    n.ios ? (oe(e).filter(function (i) {
      return i && o.lockedElements.indexOf(i) === -1;
    }).forEach(function (i) {
      i.ontouchstart = function (s) {
        var c = s.targetTouches[0],
          u = c.clientX,
          b = c.clientY;
        o.initialClientPos = {
          clientX: u,
          clientY: b
        };
      }, i.ontouchmove = function (s) {
        ie(s, i, o.initialClientPos);
      }, o.lockedElements.push(i);
    }), ce(o)) : o.lockedNum <= 0 && (o.unLockCallback = n.android ? le() : re()), o.lockedNum += 1;
  }
}
function T(e) {
  if (!C()) {
    var t = S(e);
    if (t.lockedNum = 0, !ae(t)) {
      if (t.lockedElements.length) for (var n = t.lockedElements.pop(); n;) {
        n.ontouchmove = null, n.ontouchstart = null, n = t.lockedElements.pop();
      }
      de(t);
    }
  }
}
function ae(e) {
  return _().ios || typeof e.unLockCallback != "function" ? !1 : (e.unLockCallback(), !0);
}
function ce(e) {
  _().ios && (e.documentListenerAdded || (document.addEventListener("touchmove", E(), D({
    passive: !1
  })), e.documentListenerAdded = !0));
}
function de(e) {
  e.documentListenerAdded && (document.removeEventListener("touchmove", E(), D({
    passive: !1
  })), e.documentListenerAdded = !1);
}
var B = {
    xLarge: "\n    padding: 16px 40px;\n    font-size: 20px;\n    line-height: 32px;\n  ",
    large: "\n    padding: 16px 30px;\n    font-size: 18px;\n    line-height: 24px;\n  ",
    medium: "\n    padding: 12px 22px;\n    font-size: 16px;\n    line-height: 24px;\n  ",
    small: "\n    padding: 8px 20px;\n    font-size: 14px;\n    line-height: 24px;\n  ",
    xSmall: "\n    padding: 8px 16px;\n    font-size: 12px;\n    line-height: 16px;\n  "
  },
  ue = a(["&&{background:", ";cursor:default;@media (hover:hover) and (pointer:fine){&:hover{background:", ";text-decoration:none;}}}"], function (_ref9) {
    var e = _ref9.theme;
    return e.colors.black80;
  }, function (_ref10) {
    var e = _ref10.theme;
    return e.colors.black80;
  }),
  pe = r.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: fit-content;\n  border-radius: 8px;\n  border: none;\n  font-weight: 700;\n  outline: none;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n  height: fit-content;\n  font-family: inherit;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref11) {
    var e = _ref11.theme;
    return e.colors.black100;
  }, function (_ref12) {
    var _B$e;
    var e = _ref12.size;
    return (_B$e = B[e]) !== null && _B$e !== void 0 ? _B$e : B.small;
  }, function (_ref13) {
    var e = _ref13.disabled;
    return e && ue;
  }, function (_ref14) {
    var e = _ref14.$fit;
    return e && a(["width:fit-content;height:fit-content;"]);
  }),
  fe = r.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  & > svg {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"])), function (_ref15) {
    var e = _ref15.$margin,
      t = _ref15.$position;
    return t === "left" ? 0 : "".concat(e, "px");
  }, function (_ref16) {
    var e = _ref16.$margin,
      t = _ref16.$position;
    return t === "right" ? 0 : "".concat(e, "px");
  }),
  I = function I(_ref17) {
    var e = _ref17.position,
      t = _ref17.Icon,
      n = _ref17.size;
    var o = he[n],
      i = ["small", "xSmall"].includes(n) ? 4 : 8;
    return t ? /* @__PURE__ */l(fe, {
      $position: e,
      $margin: i,
      children: /* @__PURE__ */l(t, {
        size: o
      })
    }) : null;
  },
  x = /*#__PURE__*/h(function (_ref18, w) {
    var _ref18$size = _ref18.size,
      e = _ref18$size === void 0 ? "medium" : _ref18$size,
      _ref18$disabled = _ref18.disabled,
      t = _ref18$disabled === void 0 ? !1 : _ref18$disabled,
      n = _ref18.onClick,
      o = _ref18.children,
      i = _ref18.LeftIcon,
      s = _ref18.RightIcon,
      c = _ref18.tabIndex,
      _ref18$fit = _ref18.fit,
      u = _ref18$fit === void 0 ? !1 : _ref18$fit,
      b = _ref18.name,
      p = _ref18.value,
      g = _ref18.className,
      _ref18$type = _ref18.type,
      f = _ref18$type === void 0 ? "button" : _ref18$type,
      v = _objectWithoutProperties(_ref18, _excluded2);
    return /* @__PURE__ */k(pe, _objectSpread(_objectSpread({
      size: e,
      disabled: t,
      onClick: n,
      tabIndex: c,
      $fit: u,
      name: b,
      value: p,
      className: g,
      type: f,
      ref: w
    }, v), {}, {
      children: [/* @__PURE__ */l(I, {
        Icon: i,
        size: e,
        position: "left"
      }), o, /* @__PURE__ */l(I, {
        Icon: s,
        size: e,
        position: "right"
      })]
    }));
  }),
  he = {
    xLarge: 32,
    large: 32,
    medium: 24,
    small: 16,
    xSmall: 16
  },
  be = r(x)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref19) {
    var e = _ref19.theme;
    return e.colors.blue60;
  }, function (_ref20) {
    var e = _ref20.theme;
    return e.colors.blue50;
  });
/*#__PURE__*/h(function (_ref21, n) {
  var e = _ref21.as,
    t = _objectWithoutProperties(_ref21, _excluded3);
  return /* @__PURE__ */l(be, _objectSpread({
    ref: n,
    forwardedAs: e
  }, t));
});
var ge = r(x)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref22) {
  var e = _ref22.theme;
  return e.colors.darkBlue40;
}, function (_ref23) {
  var e = _ref23.theme;
  return e.colors.darkBlue30;
});
/*#__PURE__*/h(function (e, t) {
  return /* @__PURE__ */l(ge, _objectSpread({
    ref: t
  }, e));
});
var ve = r(x)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref24) {
  var e = _ref24.theme;
  return e.colors.purple40;
}, function (_ref25) {
  var e = _ref25.theme;
  return e.colors.purple30;
});
/*#__PURE__*/h(function (e, t) {
  return /* @__PURE__ */l(ve, _objectSpread({
    ref: t
  }, e));
});
var me = a(["&&{pointer-events:none;background:transparent;color:", ";cursor:default;@media (hover:hover) and (pointer:fine){&:hover{background:transparent;}}& > svg{fill:", ";}}"], function (_ref26) {
    var e = _ref26.theme;
    return e.colors.black80;
  }, function (_ref27) {
    var e = _ref27.theme;
    return e.colors.black80;
  }),
  xe = r(x)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: transparent;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n  ", ";\n"])), function (_ref28) {
    var e = _ref28.theme;
    return e.colors.blue50;
  }, function (_ref29) {
    var e = _ref29.theme;
    return e.colors.blue30;
  }, function (_ref30) {
    var e = _ref30.theme;
    return e.colors.blue30;
  }, function (_ref31) {
    var e = _ref31.disabled;
    return e && me;
  }),
  we = /*#__PURE__*/h(function (e, t) {
    return /* @__PURE__ */l(xe, _objectSpread({
      ref: t
    }, e));
  }),
  ke = r(we)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  padding: 0;\n"]))),
  $e = /*#__PURE__*/h(function (e, t) {
    return /* @__PURE__ */l(ke, _objectSpread({
      ref: t
    }, e));
  }),
  ye = a(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref32) {
    var e = _ref32.theme;
    return e.colors.black80;
  }),
  Le = r(x)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref33) {
    var e = _ref33.theme;
    return e.colors.blue60;
  }, function (_ref34) {
    var e = _ref34.theme;
    return e.colors.blue50;
  }, function (_ref35) {
    var e = _ref35.disabled;
    return e && ye;
  }),
  Ce = /*#__PURE__*/h(function (_ref36, n) {
    var e = _ref36.children,
      t = _objectWithoutProperties(_ref36, _excluded4);
    return /* @__PURE__ */l(Le, _objectSpread(_objectSpread({
      ref: n,
      "aria-label": "icon-button"
    }, t), {}, {
      children: e
    }));
  }),
  Se = a(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref37) {
    var e = _ref37.theme;
    return e.colors.black80;
  }),
  _e = r(x)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref38) {
    var e = _ref38.theme;
    return e.colors.darkBlue40;
  }, function (_ref39) {
    var e = _ref39.theme;
    return e.colors.darkBlue30;
  }, function (_ref40) {
    var e = _ref40.disabled;
    return e && Se;
  });
/*#__PURE__*/h(function (_ref41, n) {
  var e = _ref41.children,
    t = _objectWithoutProperties(_ref41, _excluded5);
  return /* @__PURE__ */l(_e, _objectSpread(_objectSpread({
    ref: n
  }, t), {}, {
    children: e
  }));
});
var Ee = a(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref42) {
    var e = _ref42.theme;
    return e.colors.black80;
  }),
  ze = r(x)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref43) {
    var e = _ref43.theme;
    return e.colors.purple40;
  }, function (_ref44) {
    var e = _ref44.theme;
    return e.colors.purple30;
  }, function (_ref45) {
    var e = _ref45.disabled;
    return e && Ee;
  });
/*#__PURE__*/h(function (_ref46, n) {
  var e = _ref46.children,
    t = _objectWithoutProperties(_ref46, _excluded6);
  return /* @__PURE__ */l(ze, _objectSpread(_objectSpread({
    ref: n
  }, t), {}, {
    children: e
  }));
});
var Te = a(["&&{color:", ";&:hover{color:", ";}}"], function (_ref47) {
    var e = _ref47.theme;
    return e.colors.black100;
  }, function (_ref48) {
    var e = _ref48.theme;
    return e.colors.black100;
  }),
  Be = r(x)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n      background: ", ";\n    }\n  }\n\n  ", ";\n"])), function (_ref49) {
    var e = _ref49.theme;
    return e.colors.blue50;
  }, function (_ref50) {
    var e = _ref50.theme;
    return e.colors.blue95;
  }, function (_ref51) {
    var e = _ref51.theme;
    return e.colors.blue30;
  }, function (_ref52) {
    var e = _ref52.theme;
    return e.colors.blue90;
  }, function (_ref53) {
    var e = _ref53.disabled;
    return e && Te;
  });
/*#__PURE__*/h(function (e, t) {
  return /* @__PURE__ */l(Be, _objectSpread({
    ref: t
  }, e));
});
var Ie = a(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref54) {
    var e = _ref54.theme;
    return e.colors.black80;
  }),
  Oe = r(x)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref55) {
    var e = _ref55.theme;
    return e.colors.blue95;
  }, function (_ref56) {
    var e = _ref56.theme;
    return e.colors.blue90;
  }, function (_ref57) {
    var e = _ref57.disabled;
    return e && Ie;
  });
/*#__PURE__*/h(function (_ref58, n) {
  var e = _ref58.children,
    t = _objectWithoutProperties(_ref58, _excluded7);
  return /* @__PURE__ */l(Oe, _objectSpread(_objectSpread({
    ref: n
  }, t), {}, {
    children: e
  }));
});
r($e)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1;\n  ", ";\n"])), function (_ref59) {
  var e = _ref59.theme,
    t = _ref59.$danger;
  return t && a(["color:", ";&:hover{color:", ";}@media (hover:none){&:hover{color:", ";}}"], e.colors.red60, e.colors.red40, function (_ref60) {
    var n = _ref60.theme;
    return n.colors.red60;
  });
});
var U = r.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  position: fixed;\n  display: flex;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: -1;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n"]))),
  Pe = r.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral([""]))),
  Ae = {
    xl: a(["width:1020px;& > [data-id='content-box']{padding:0 32px 32px;}"]),
    l: a(["width:720px;& > [data-id='content-box']{padding:0 32px 32px;}"]),
    m: a(["width:560px;"]),
    s: a(["width:440px;"]),
    xs: a(["width:304px;"])
  },
  Fe = r.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n\n  z-index: ", ";\n  ", ";\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref61) {
    var e = _ref61.theme;
    return e.zIndex.modal;
  }, function (_ref62) {
    var e = _ref62.$open;
    if (!e) return a(["visibility:hidden;& ", "{visibility:hidden;}"], U);
  }),
  Re = 16,
  Me = r.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 8px;\n  border-radius: ", "px;\n  ", "\n  background: ", ";\n  & > [data-id='content-box'] {\n    padding: 0 24px 32px;\n  }\n  ", ";\n"])), Re, M, function (_ref63) {
    var e = _ref63.theme;
    return e.colors.black100;
  }, function (_ref64) {
    var e = _ref64.size;
    return Ae[e];
  }),
  je = r(Ce)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  && {\n    width: fit-content;\n  }\n"]))),
  Ve = r.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px;\n  margin-bottom: 8px;\n"]))),
  Ne = function Ne(_ref65) {
    var _ref65$open = _ref65.open,
      e = _ref65$open === void 0 ? !1 : _ref65$open,
      _ref65$disableEscapeK = _ref65.disableEscapeKeyDown,
      t = _ref65$disableEscapeK === void 0 ? !1 : _ref65$disableEscapeK,
      n = _ref65.onClose,
      o = _ref65.children,
      _ref65$showCloseButto = _ref65.showCloseButton,
      i = _ref65$showCloseButto === void 0 ? !0 : _ref65$showCloseButto,
      _ref65$showOverlay = _ref65.showOverlay,
      s = _ref65$showOverlay === void 0 ? !1 : _ref65$showOverlay,
      c = _ref65.container,
      _ref65$size = _ref65.size,
      u = _ref65$size === void 0 ? "m" : _ref65$size,
      b = _objectWithoutProperties(_ref65, _excluded8);
    var p = z(null),
      g = z(null);
    L(function () {
      var d = g.current;
      return e ? se(d) : T(), function () {
        return T();
      };
    }, [e]);
    var f = function f(d) {
      p.current && (n == null || n(p.current, d));
    };
    X(g, function () {
      e && f();
    }), L(function () {
      var d = function d(m) {
        m.key === "Escape" && !t && p.current && (n == null || n(p.current));
      };
      return e ? window.addEventListener("keydown", d) : window.removeEventListener("keydown", d), function () {
        return window.removeEventListener("keydown", d);
      };
    }, [n, e, t]);
    var v = /* @__PURE__ */k(Fe, _objectSpread(_objectSpread({
        $open: e,
        role: "dialog",
        "aria-modal": !0,
        ref: p
      }, b), {}, {
        children: [s && /* @__PURE__ */l(U, {
          "aria-hidden": !0,
          tabIndex: -1
        }), /* @__PURE__ */k(Me, {
          "data-id": "modal-box",
          tabIndex: 0,
          ref: g,
          size: u,
          children: [i && /* @__PURE__ */l(Ue, {
            onClose: f
          }), /* @__PURE__ */l(Pe, {
            "data-id": "content-box",
            children: o
          })]
        })]
      })),
      w = Y();
    return c === null || w ? v : /*#__PURE__*/Z(v, De({
      container: c
    }));
  },
  De = function De(_ref66) {
    var e = _ref66.container;
    var t;
    return typeof e == "string" ? t = document.getElementById(e) : t = e, t || (document == null ? void 0 : document.body);
  },
  Ue = function Ue(_ref67) {
    var e = _ref67.onClose;
    return /* @__PURE__ */l(Ve, {
      children: /* @__PURE__ */l(je, {
        onClick: e,
        "aria-label": "close",
        tabIndex: 0,
        children: /* @__PURE__ */l(V, {})
      })
    });
  },
  We = 8,
  He = r.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral([""]))),
  Ze = r.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  position: relative;\n  width: fit-content;\n  height: 100%;\n  ", "\n  border-radius: ", "px;\n"])), M, We),
  O = r.iframe(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"]))),
  W = r(N)(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  stroke: none;\n"]))),
  Ge = r.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  width: fit-content;\n  height: 100%;\n  cursor: pointer;\n  &:hover {\n    ", " {\n      fill: ", ";\n    }\n  }\n"])), W, function (_ref68) {
    var e = _ref68.theme;
    return e.colors.blue40;
  }),
  Xe = r.img(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"]))),
  Ye = r(Ne)(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  [data-id='modal-box'] {\n    ", ";\n    ", ";\n  }\n\n  [data-id='content-box'] {\n    width: 100%;\n    height: 100%;\n  }\n"])), function (_ref69) {
    var e = _ref69.width;
    return e && "width: ".concat(e);
  }, function (_ref70) {
    var e = _ref70.height;
    return e && "height: ".concat(e);
  }),
  nt = function nt(_ref71) {
    var e = _ref71.src,
      _ref71$autoPlay = _ref71.autoPlay,
      t = _ref71$autoPlay === void 0 ? !1 : _ref71$autoPlay,
      n = _ref71.image,
      o = _ref71.modal,
      _ref71$isRunning = _ref71.isRunning,
      i = _ref71$isRunning === void 0 ? !1 : _ref71$isRunning,
      s = _objectWithoutProperties(_ref71, _excluded9);
    var c = "".concat(e, "?autoplay=").concat(t ? 1 : 0),
      _P3 = P(!!i),
      _P4 = _slicedToArray(_P3, 2),
      u = _P4[0],
      b = _P4[1],
      p = function p() {
        var d, m;
        b(!0), (m = (d = n == null ? void 0 : n.playButton) == null ? void 0 : d.onClick) == null || m.call(d);
      },
      f = u || !!!n,
      v = !!o,
      w = v ? _objectSpread(_objectSpread({}, o), {}, {
        open: u,
        onClose: function onClose() {
          var _m;
          var m;
          for (var _len = arguments.length, d = new Array(_len), _key = 0; _key < _len; _key++) {
            d[_key] = arguments[_key];
          }
          b(!1), (m = o == null ? void 0 : o.onClose) == null || (_m = m).call.apply(_m, [o].concat(d));
        }
      }) : void 0;
    return /* @__PURE__ */k(He, _objectSpread(_objectSpread({}, s), {}, {
      children: [f && /* @__PURE__ */l(Ke, {
        modal: w,
        src: c
      }), /* @__PURE__ */l(Ze, {
        style: {
          visibility: f ? "hidden" : "visible"
        },
        children: (v || !f) && /* @__PURE__ */l(qe, {
          image: n,
          onClick: p
        })
      })]
    }));
  },
  Ke = function Ke(_ref72) {
    var e = _ref72.src,
      t = _ref72.modal,
      n = _objectWithoutProperties(_ref72, _excluded10);
    var o = {
      src: e,
      frameBorder: "0",
      allow: "autoplay",
      title: "hn-video"
    };
    return t ? /* @__PURE__ */l(Ye, _objectSpread(_objectSpread(_objectSpread({}, t), n), {}, {
      children: /* @__PURE__ */l(O, _objectSpread({}, o))
    })) : /* @__PURE__ */l(O, _objectSpread({}, o));
  },
  qe = function qe(_ref73) {
    var e = _ref73.image,
      t = _ref73.onClick,
      n = _objectWithoutProperties(_ref73, _excluded11);
    if (!e) return null;
    var o = e.source,
      i = e.playButton;
    return /* @__PURE__ */k(Ge, _objectSpread(_objectSpread({
      onClick: t
    }, n), {}, {
      children: [typeof o == "string" ? /* @__PURE__ */l(Xe, {
        src: o,
        alt: "preview"
      }) : o, /* @__PURE__ */l(W, {
        size: i == null ? void 0 : i.size
      })]
    }));
  };
export { nt as VideoPlayer };